import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { TopBar, Nav, Hero, TrustBar, Services, Payments, About } from "@/components/Sections";
import { WelcomeBanner } from "@/components/WelcomeBanner";
import { ServicesCategories } from "@/components/ServicesCategories";
import { SimpleWords } from "@/components/SimpleWords";
import { Founder } from "@/components/Founder";
import { Standards } from "@/components/Standards";
import { FintechFooter } from "@/components/FintechFooter";
import { Contact, Footer } from "@/components/ContactFooter";
import { ChatWidget } from "@/components/ChatWidget";
import { CookieBanner } from "@/components/CookieBanner";
import { LanguageProvider } from "@/LanguageContext";
import LegalPage from "@/pages/LegalPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { AuthProvider } from "@/AuthContext";
import { PRIVACY } from "@/legal/privacy";
import { TERMS } from "@/legal/terms";
import { COMPLAINTS } from "@/legal/complaints";
import { REFUNDS } from "@/legal/refunds";
import { COOKIES } from "@/legal/cookies";

const Home = () => (
  <div className="min-h-screen bg-white" data-testid="home-page">
    <TopBar />
    <Nav />
    <main>
      <WelcomeBanner />
      <Hero />
      <TrustBar />
      <ServicesCategories />
      <SimpleWords />
      <Services />
      <Payments />
      <About />
      <Founder />
      <Standards />
      <Contact />
    </main>
    <FintechFooter />
    <Footer />
    <ChatWidget />
  </div>
);

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <Toaster position="top-center" richColors closeButton />
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacy-policy" element={<LegalPage doc={PRIVACY} />} />
              <Route path="/terms" element={<LegalPage doc={TERMS} />} />
              <Route path="/complaints-policy" element={<LegalPage doc={COMPLAINTS} />} />
              <Route path="/cancellation-refund-policy" element={<LegalPage doc={REFUNDS} />} />
              <Route path="/cookie-policy" element={<LegalPage doc={COOKIES} />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
            <CookieBanner />
          </AuthProvider>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
